import { Injectable } from '@angular/core';
import { RepositoryService } from '@get/services/repository';
import { GeneratedSocieteEspaceApiService } from './societe-espace-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteEspaceApiService extends GeneratedSocieteEspaceApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}

